import { useRef, useState, useLayoutEffect } from 'react';

import { Box } from '@mui/material';

function LinearArc() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 1200 753"
      fill="none"
    >
      <path
        d="M499.168 0C144.785 20.7041 -136.207 314.642 -136.207 674.225V742.767C-136.207 745.954 -135.778 749.112 -134.949 752.137H-113.249C-30.936 427.017 263.531 186.442 614.23 186.442H1200V0H499.168Z"
        fill="url(#paint0_linear_4454_64959)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4454_64959"
          x1="822.987"
          y1="621.428"
          x2="328.956"
          y2="-25.827"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC6743" />
          <stop offset="1" stopColor="#EDE3C5" stopOpacity="0.4" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function LinearArc2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 1200 567"
      fill="none"
    >
      <path
        d="M614.229 0.441406C263.529 0.441406 -30.9375 241.016 -113.25 566.137H-74.3208C30.4751 342.754 257.362 188.054 520.429 188.054H1200V0.441406H614.229Z"
        fill="url(#paint0_linear_4454_64958)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4454_64958"
          x1="1084.3"
          y1="24.7141"
          x2="565.485"
          y2="1128.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC6743" />
          <stop offset="1" stopColor="#EDE3C5" stopOpacity="0.4" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default function ArtBackground() {
  const firstArcRef = useRef<HTMLDivElement>(null);
  const [secondArcTop, setSecondArcTop] = useState(0);

  useLayoutEffect(() => {
    const updateSecondArcPosition = () => {
      if (firstArcRef.current) {
        const firstArcHeight = firstArcRef.current.offsetHeight;
        const _secondArcTop = firstArcHeight * 0.24;
        setSecondArcTop(_secondArcTop);
      }
    };

    updateSecondArcPosition();
    window.addEventListener('resize', updateSecondArcPosition);

    return () => window.removeEventListener('resize', updateSecondArcPosition);
  }, []);

  return (
    <Box width="100%" position="absolute" top={0} right={0} zIndex={-1}>
      <Box ref={firstArcRef} position="absolute" top={0} right={0} width="100%">
        <LinearArc />
      </Box>
      <Box position="absolute" top={secondArcTop} right={0} width="100%">
        <LinearArc2 />
      </Box>
    </Box>
  );
}
